import './App.css';
// import PlaceholderPage from './components/pages/PlaceholderPage'
import Layout from './components/Layout';

function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;